import getPageLang from './getPageLang';
import channels from '../components/BlockChannels/channels';

export default function getVideo(key) {
    const locale = getPageLang() === 'ru' ? 'ru' : 'en';
    const channel = channels.find((i) => i.id === key);

    if (!channel) {
        throw new Error(`${key} not found in channels`);
    }

    return {
        src: channel.links[0][locale].src,
        preview: channel.links[0][locale].preview,
        alt: channel.links[0][locale].alt,
    };
}
